module.exports = __webpack_public_path__ + "img/instructions_04.8ed1fb13.svg";